import UserTable from "../components/UserTable";

function AdminUserList() {
    return (
        <>
            <UserTable />
        </>
    )
}

export default AdminUserList;